module.exports = __webpack_public_path__ + "img/downloaded-document.6c81d039.svg";